import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "essay-modal flex-column" }
const _hoisted_2 = { class: "essay-modal_ctt flex-column" }
const _hoisted_3 = {
  key: 0,
  class: "essay-modal_exercise flex-column"
}
const _hoisted_4 = { class: "flex-row justify-between" }
const _hoisted_5 = {
  id: "questionsIndex",
  class: "questions-index flex-row align-center"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "clock-submit" }
const _hoisted_8 = {
  key: 0,
  class: "clock-submit_countdown mr-2"
}
const _hoisted_9 = {
  key: 0,
  class: "countdown-time common-color"
}
const _hoisted_10 = {
  key: 1,
  class: "countdown-time common-color"
}
const _hoisted_11 = {
  key: 0,
  id: "answerClass",
  class: "exercise-questions answer-index flex-row mt-3"
}
const _hoisted_12 = { class: "question-title_title weight-700" }
const _hoisted_13 = { class: "question-title_answer" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "essay-modal_exercise flex-column"
}
const _hoisted_24 = { class: "exercise-questions flex-column mt-5" }
const _hoisted_25 = { class: "question-title_option" }
const _hoisted_26 = { class: "question-title_title weight-700" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "exercise-questions-analyze_title weight-600 mb-2" }
const _hoisted_35 = { class: "flex-row flex-wrap" }
const _hoisted_36 = { class: "exercise-questions-analyze_text mr-5" }
const _hoisted_37 = { class: "common-color" }
const _hoisted_38 = { class: "exercise-questions-analyze_text" }
const _hoisted_39 = { class: "mt-2" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = {
  key: 2,
  class: "essay-modal_glossary"
}
const _hoisted_42 = { class: "essay-modal_glossary-grid" }
const _hoisted_43 = { class: "essay-modal_glossary-text text-center" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 3,
  class: "display_content"
}
const _hoisted_46 = {
  key: 4,
  class: "display_content"
}
const _hoisted_47 = {
  key: 5,
  class: "display_content"
}

import { onMounted, ref, watch } from "vue"
import { useRoute } from "vue-router"
import http from "@/js/http"
import {
  IonButton,
  IonCol,
  IonGrid,
  IonRow,
  IonSelect,
  modalController,
  popoverController,
} from "@ionic/vue"
import Text from "@/components/MarkdownText.vue"
import store from "@/js/store"
import { useExerciseCountdownStore } from "@/hooks/useExerciseCountdown"
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore"
import { openMsgToast, openProblematicAlert } from "@/views/AIGenerate/openModal"
import { useGlossaryStore } from "@/hooks/useGlossary"
import { useEssayGenerateContentStore } from "@/hooks/useEssayGenerateContentStore"
import { default_exercise_answer } from "@/views/AIGenerate/smartReading/defaultData"
import PageDialog from "@/components/PageDialog.vue"
import { useStorage } from "@vueuse/core/index"
import { getArticleDetail } from "@/views/reading/newReadingArticle/components/articleMethod"
import KeywordPopover from "./components/KeywordPopover.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleModal',
  props: [
  "word",
  "type",
  "title",
  "questions",
  "exerciseObj",
  "isFullscreen",
  "readingId",
  "fromPrepareOrigin",
  "adminToken",
  "aptmId",
],
  emits: [
  "closeCurrentHalfModal",
  "openModalFullScreen",
  "closeModalHalfScreen",
  "update:exerciseObj",
],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const countdownStore = useExerciseCountdownStore()
const contentStore = useEssayGenerateContentStore()
const currentStepStore = useCurrentStepStore()
const glossaryStore = useGlossaryStore()
const route = useRoute()

const type = ref()
const selectWord = ref()
const studentInfo = ref()
const glossaryArr: any = ref([])
const modalIsFold = ref("expand")
const currentExeValue = ref({ type: "exercise", title: "Questions" })
let answerArr: any = []
const answerIndex = ref(1) // 当前答题的序号
const exerciseProcess = ref(0)
const checkValues = ref(props.exerciseObj?.question || default_exercise_answer)
const isFullscreen = ref(false)
const twiceCheckValues = ref<any>([])
const glossaryList = useStorage("GLOSSARY_ARRAY", [], localStorage)

function openModalFullScreen() {
  emit("openModalFullScreen")
}

function closeModalHalfScreen() {
  emit("closeModalHalfScreen")
}

function initCheckedValues() {
  const obj = props.exerciseObj

  if (!obj) {
    return
  }

  if (currentStepStore.currentStep === 2) {
    // 泛读答题
    answerArr = obj.answer ? obj.answer.split(",") : obj.question?.map(() => "")
  } else if (currentStepStore.currentStep === 7) {
    // 再次答题
    answerArr = obj.againAnswer ? obj.againAnswer.split(",") : obj.question?.map(() => "")
  }

  const arr = obj.question?.map((i: Record<string, any>, index: number) => {
    i["value"] = answerArr[index]
    i["id"] = index + 1
    return i
  })
  exerciseProcess.value = (arr || []).filter((item: any) => item.value).length

  return arr
}

async function checkQuestionAnswer(idx: number, answer: string) {
  if (checkValues.value[idx]["value"] !== answer) {
    checkValues.value[idx]["value"] = answer
  } else {
    checkValues.value[idx]["value"] = ""
  }
  exerciseProcess.value = (checkValues.value || []).filter((item: any) => item.value).length

  if (checkValues.value[idx]["value"]) {
    if (idx === checkValues.value.length - 1) {
      const modal = await modalController.create({
        id: "PageDialog",
        component: PageDialog,
        componentProps: {
          message: "是否提交答案并跳转到下一流程？",
          type: "hasCancel",
        },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data === "NEXT") {
        await submitAnswer()
      }
    } else {
      chooseQuestionIndex(idx + 2, "answer")
    }
  }
}

async function didDismiss() {
  modalIsFold.value = "fold"
  await modalController.dismiss({
    value: checkValues.value,
    step: currentStepStore.currentStep,
    fold: modalIsFold.value,
  })
}

// 先调取接口,再删除
function deleteWordFromGlossary(id: number, item: Record<string, any>) {
  const appointment = store.getAppointment()
  if (id) {
    http
      .get("/vocabulary/deleteVocabularyPersonal?id=" + id)
      .then((res) => {
        if (res.data.success) {
          openMsgToast("成功删除")
          glossaryStore.getGlossaryList(appointment.studentId, appointment.courseTypeId)
          removeGlossaryFromLocal(item.word)
        } else {
          openMsgToast("删除失败")
        }
      })
      .catch((e) => {
        throw e
      })
  } else {
    openMsgToast("不合法的单词")
  }
}

function removeGlossaryFromLocal(word: string) {
  let arr: any = []
  for (let i = 0; i < glossaryList.value.length; i++) {
    if (word !== glossaryList.value[i].word) {
      arr.push(glossaryList.value[i])
    } else {
      const glossaryDom: any = document.querySelector("#" + glossaryList.value[i].id)
      glossaryDom.style.backgroundColor = "transparent"
    }
  }
  console.log(arr)
  glossaryList.value = arr
}

async function closeCurrentHalfModal() {
  console.log("关闭弹窗")
  emit("closeCurrentHalfModal")
}

// 修改答案后重新获取AI智阅相关内容
// admin预览文章，需要传递admin的token给app的api请求头
async function getNewGenerateContent() {
  const aptmId = props.aptmId ? props.aptmId : store.getAppointment().aptmId
  let resData = await getArticleDetail(props.readingId, aptmId, props.adminToken)
  if (props.fromPrepareOrigin) {
    resData = { ...resData, answer: checkValues.value.map((item: any) => item.value).join(",") }
  }
  emit("update:exerciseObj", resData)
}

const questionRefs = ref<any>([])

function chooseQuestionIndex(idx: number, from?: string) {
  answerIndex.value = idx
  const question = props.exerciseObj?.question || "[]"
  const $questionsIndex = document.getElementById("questionsIndex")
  const $active = document.getElementById("activeLine")
  const $answerClass = document.getElementById("answerClass")
  const left = questionRefs.value[idx - 1].offsetLeft
  const width = questionRefs.value[idx - 1].offsetWidth
  if (question) {
    $answerClass.style.transform = `translate3d(-${(idx - 1) * 100}vw, 0, 0)`
    $active.style.left = left + "px"
    $active.style.width = width + "px"
    // 平滑滚动
    if (from == "answer") {
      // 如果是选择答案，则自动
      $questionsIndex.scrollTo({
        left: questionRefs.value[idx - 1].offsetLeft - 10,
        behavior: "smooth",
      })
    }

    /* if(idx < questionRefs.value.length) {
      const nextLeft = questionRefs.value[idx].offsetLeft
      $questionsIndex?.scrollTo({
        left: left+20,
        behavior: "smooth"
      })
    }*/
  }
}

// 提交答案
async function submitAnswer() {
  const totalLen = checkValues.value ? checkValues.value.length : 0
  const fillInputLen = (checkValues.value || []).filter((item: any) => item.value).length
  if (fillInputLen !== totalLen) {
    const alertParams = {
      message: `剩余${totalLen - fillInputLen}题未作答,是否提交？`,
      buttons: [
        {
          text: "取消",
          role: "cancel",
        },
        {
          text: "确认",
          role: "confirm",
          handler: async () => {
            postAnswerIntoDb()
            countdownStore.terminateCountdownFun() // 终止倒计时
            await openMsgToast("成功提交答案！")
            // await modalController.dismiss().catch(e => console.log(e))
            await afterSubmitAnswer()
          },
        },
      ],
    }
    await openProblematicAlert(alertParams)
  } else {
    postAnswerIntoDb()
    countdownStore.terminateCountdownFun() // 终止倒计时
    await openMsgToast("成功提交答案！")
    // await modalController.dismiss().catch(e => console.log(e))
    await afterSubmitAnswer()
  }
}

async function afterSubmitAnswer() {
  await getNewGenerateContent()
  currentStepStore.controlStepData() // 处理流程执行数据
  currentStepStore.handleProgressTitleNameArr() // 动态展示流程名称
  await currentStepStore.handleProgressStepEvent(closeCurrentHalfModal) // 处理每个流程相关的事件
}

function postAnswerIntoDb() {
  props.exerciseObj.btnDisabled = true
  emit("update:exerciseObj", props.exerciseObj)
  if (props.fromPrepareOrigin) {
    return
  }
  const answerData = (checkValues.value || []).map((item: any) => item.value).join(",")
  if (currentStepStore.currentStep === 2) {
    // 泛读答题
    const params = {
      aptmId: store.getAppointment().aptmId,
      answer: answerData,
      teacherId: store.getAppointment().teacherId,
      studentId: store.getAppointment().studentId,
      readingId: props.readingId,
      answerId: props.exerciseObj?.answerId,
    }
    http.post("/read/modifyOrInsertStudentAnswers", params).then((res) => {
      console.log(res)
      if (res.data.code === 200) {
        localStorage.setItem("answerId", res.data.data)
      }
    })
  } else if (currentStepStore.currentStep === 7) {
    // 再次作答
    const params = {
      againAnswer: answerData,
      answerId: props.exerciseObj?.answerId,
    }
    http.post("/read/modifyOrInsertStudentAnswers", params).then((res) => {
      console.log(res)
    })
  }
}

async function showKeywordPopover(event: any) {
  let descContent = event.target.getAttribute("desc-content")
  const popover = await popoverController.create({
    component: KeywordPopover,
    componentProps: {
      descContent: descContent,
    },
    event: event,
    align: "center",
    reference: "event",
    showBackdrop: false,
  })
  popover.present()
}

watch(
  () => currentStepStore.currentStep,
  () => {
    if (currentStepStore.currentStep === 2 || currentStepStore.currentStep === 7) {
      checkValues.value = initCheckedValues()
      // 答题的样式和序号回到第一题
      answerIndex.value = 1
    }

    // 查看解析
    if (currentStepStore.currentStep === 8) {
      const obj = props.exerciseObj
      const firstList = (obj?.answer || ",,,,").split(",")
      const secondList = (obj?.againAnswer || ",,,,").split(",")
      const num = firstList.length
      for (let i = 0; i <= num; i++) {
        twiceCheckValues.value[i] = {
          first: firstList[i],
          second: secondList[i],
        }
      }
      setTimeout(() => {
        const el = document.getElementsByClassName("exercise-questions")[0]
        const keywords = el.querySelectorAll(".keyword-content")
        keywords.forEach((keyword) => {
          keyword.classList.add("keyword-content-text")
          keyword.addEventListener("click", function (ev) {
            showKeywordPopover(ev)
          })
        })
      }, 100)
    }
  },
  { immediate: true, deep: true }
)

onMounted(() => {
  glossaryArr.value.push(props.word)
  selectWord.value = props.word
  type.value = props.type

  //初始化答题进度
  // checkValues.value = initCheckedValues()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ([2, 7].includes(_unref(currentStepStore).currentStep))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkValues.value, (val, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    ref_for: true,
                    ref_key: "questionRefs",
                    ref: questionRefs,
                    key: index,
                    class: _normalizeClass(["cursor-pointer", { 'index-spacing': index !== 0 }]),
                    style: _normalizeStyle({
                color: val.value ? 'var(--text-import-color)' : 'var(--font-gray)',
              }),
                    onClick: ($event: any) => (chooseQuestionIndex(index + 1))
                  }, _toDisplayString(index + 1) + "题 ", 15, _hoisted_6))
                }), 128)),
                _createElementVNode("div", {
                  id: "activeLine",
                  class: _normalizeClass(["index-nav", [_unref(currentStepStore).currentStep === 7 ? 'again-nav-index' : '']])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_unref(currentStepStore).currentStep === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-jishi countdown-img" }, null, -1)),
                      (_unref(currentStepStore).currentStep === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(countdownStore)?.testCountdown ? _unref(countdownStore)?.testCountdown : "00:00"), 1))
                        : _createCommentVNode("", true),
                      ([7].includes(_unref(currentStepStore).currentStep))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "00:00"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonButton), {
                  class: "green_bg text-size",
                  shape: "round",
                  onClick: submitAnswer
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("提交 ")
                  ])),
                  _: 1,
                  __: [1]
                })
              ])
            ]),
            (props.exerciseObj?.question)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.exerciseObj?.question, (question, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "question-title flex-column"
                    }, [
                      _createElementVNode("span", _hoisted_12, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "" }, "【", -1)),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(checkValues.value[index]["value"]), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "" }, "】", -1)),
                        _createTextVNode(" " + _toDisplayString(question.index) + ". ", 1),
                        _createElementVNode("span", {
                          innerHTML: question?.question?.replace(/^\[.+\]/m, '')
                        }, null, 8, _hoisted_14)
                      ]),
                      (question.a)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([{ 'option-active': checkValues.value[index]['value'] === 'A' }, "question-title_option cursor-pointer mt-1"]),
                            onClick: ($event: any) => (checkQuestionAnswer(+index, 'A'))
                          }, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "display-inline-block mr-3 question-title_option_word" }, "A ", -1)),
                            _createElementVNode("span", {
                              innerHTML: question.a
                            }, null, 8, _hoisted_16)
                          ], 10, _hoisted_15))
                        : _createCommentVNode("", true),
                      (question.b)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([{ 'option-active': checkValues.value[index]['value'] === 'B' }, "question-title_option cursor-pointer"]),
                            onClick: ($event: any) => (checkQuestionAnswer(+index, 'B'))
                          }, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "display-inline-block mr-3 question-title_option_word" }, "B ", -1)),
                            _createElementVNode("span", {
                              innerHTML: question.b
                            }, null, 8, _hoisted_18)
                          ], 10, _hoisted_17))
                        : _createCommentVNode("", true),
                      (question.c)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass([{ 'option-active': checkValues.value[index]['value'] === 'C' }, "question-title_option cursor-pointer"]),
                            onClick: ($event: any) => (checkQuestionAnswer(+index, 'C'))
                          }, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "display-inline-block mr-3 question-title_option_word" }, "C ", -1)),
                            _createElementVNode("span", {
                              innerHTML: question.c
                            }, null, 8, _hoisted_20)
                          ], 10, _hoisted_19))
                        : _createCommentVNode("", true),
                      (question.d)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: _normalizeClass([{ 'option-active': checkValues.value[index]['value'] === 'D' }, "question-title_option cursor-pointer"]),
                            onClick: ($event: any) => (checkQuestionAnswer(+index, 'D'))
                          }, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "display-inline-block mr-3 question-title_option_word" }, "D", -1)),
                            _createElementVNode("span", {
                              innerHTML: question.d
                            }, null, 8, _hoisted_22)
                          ], 10, _hoisted_21))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ([8].includes(_unref(currentStepStore).currentStep))
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.exerciseObj?.question, (question, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "question-title flex-column mb-5"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _createTextVNode(_toDisplayString(question?.index ?? question?.result) + ". " + _toDisplayString(/[\u4e00-\u9fa5]+/.test(question?.queType) ? question?.queType : "细节理解题") + "： ", 1),
                      _createElementVNode("span", {
                        innerHTML: question?.question
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "display-inline-block mr-2" }, "A.", -1)),
                      _createElementVNode("span", {
                        innerHTML: question.a
                      }, null, 8, _hoisted_28)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "display-inline-block mr-2" }, "B.", -1)),
                      _createElementVNode("span", {
                        innerHTML: question.b
                      }, null, 8, _hoisted_29)
                    ]),
                    (question.c)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "display-inline-block mr-2" }, "C.", -1)),
                          _createElementVNode("span", {
                            innerHTML: question.c
                          }, null, 8, _hoisted_31)
                        ]))
                      : _createCommentVNode("", true),
                    (question.d)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "display-inline-block mr-2" }, "D.", -1)),
                          _createElementVNode("span", {
                            innerHTML: question.d
                          }, null, 8, _hoisted_33)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(question?.index ?? question?.result) + ".答案 ", 1),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[12] || (_cache[12] = _createTextVNode(" 正确答案：")),
                      _createElementVNode("span", _hoisted_37, "【" + _toDisplayString(question.success) + "】", 1)
                    ]),
                    _createElementVNode("span", _hoisted_38, [
                      _cache[13] || (_cache[13] = _createTextVNode(" 首次答案：")),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                    twiceCheckValues.value[index]['first'] == question.success
                      ? 'common-color'
                      : 'common-red-color',
                  ])
                      }, [
                        _createElementVNode("span", null, "【" + _toDisplayString(twiceCheckValues.value[index]["first"] || "") + "】", 1)
                      ], 2),
                      _cache[14] || (_cache[14] = _createTextVNode(" 二次答案：")),
                      _createElementVNode("span", {
                        class: _normalizeClass([
                    twiceCheckValues.value[index]['second'] == question.success
                      ? 'common-color'
                      : 'common-red-color',
                  ])
                      }, [
                        _createElementVNode("span", null, "【" + _toDisplayString(twiceCheckValues.value[index]["second"] || "") + "】", 1)
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "blue-color weight-600 mb-3 mt-3" }, "解析：", -1)),
                    _createElementVNode("span", {
                      class: "exercise-questions-analyze_text",
                      innerHTML: question?.analysis
                    }, null, 8, _hoisted_40)
                  ])
                ])), [
                  [_vShow, props.exerciseObj?.question]
                ])
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(currentStepStore).currentStep === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(glossaryStore).glossaryList, (i, index) => {
                        return (_openBlock(), _createBlock(_unref(IonCol), {
                          key: index,
                          size: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", null, _toDisplayString(i?.word), 1),
                              _createElementVNode("i", {
                                class: "essay-modal_glossary-delete iconfont icon-guanbi-xiao cursor-pointer",
                                onClick: ($event: any) => (deleteWordFromGlossary(i.id, i))
                              }, null, 8, _hoisted_44)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(currentStepStore).currentStep === 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createVNode(Text, {
              show: true,
              "article-content": props.exerciseObj?.textCn
            }, null, 8, ["article-content"])
          ]))
        : _createCommentVNode("", true),
      (_unref(currentStepStore).currentStep === 9)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createVNode(Text, {
              show: true,
              "article-content": props.exerciseObj?.knowledge
            }, null, 8, ["article-content"])
          ]))
        : _createCommentVNode("", true),
      (_unref(currentStepStore).currentStep === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createVNode(Text, {
              show: true,
              "article-content": props.exerciseObj?.sentence ?? ''
            }, null, 8, ["article-content"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})